import { Trans } from '@gamiphy/react-i18n';
import {
  Box,
  Grid,
  LinearProgress,
  Typography,
} from '@mui/material';
import {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import { observer } from 'mobx-react';
import React from 'react';
import { BirthdayGiftStore } from '@gamiphy/loyalty-station-desktop/store/birthdayGift';
import BirthDayCountDown from './BirthdayCountDown';

const InProgress: React.FC = () => {
  const text = React.useMemo(() => {
    switch (true) {
      case BirthdayGiftStore.progress === 0:
        return (
          <Trans
            i18nKey="birthdayGift.earnTreat"
            defaults="Time to earn your birthday free treat!"
          />
        );
      case BirthdayGiftStore.progress <= 49:
        return (
          <Trans
            i18nKey="birthdayGift.onAroll"
            defaults="You're on a roll, keep going!"
          />
        );
      case BirthdayGiftStore.progress <= 69:
        return (
          <Trans
            i18nKey="birthdayGift.halfway"
            defaults="You're more than halfway there!"
          />
        );
      case BirthdayGiftStore.progress <= 99:
        return (
          <Trans
            i18nKey="birthdayGift.almostThere"
            defaults="Almost there, just a little more to go!"
          />
        );
      default:
        return undefined;
    }
  }, [BirthdayGiftStore.progress]);

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      item
      wrap="nowrap"
    >
      <Grid item>
        <Typography fontSize="2.3rem" fontWeight={700} mt={1} mb={2} align="center">
          <Trans
            i18nKey="birthdayGift.cake"
            defaults="A Birthday Cake Just For You"
          />
        </Typography>
      </Grid>
      <Grid item>
        <Typography fontSize={15} fontWeight={400} mb={2} align="center">
          {text}
        </Typography>
      </Grid>
      <Grid item>
        <BirthDayCountDown
          labelsFontSize="10px"
          fontSize="21px"
          margin="1"
        />
      </Grid>
      <Grid item>
        <LinearProgress
          value={BirthdayGiftStore.progress}
          variant="determinate"
          sx={{
            mt: 1.5,
            width: 'calc(100%)',
            borderRadius: '100px',
            height: 12,
            bgcolor: '#EAEAEA',
            [`& .${linearProgressClasses.bar}`]: {
              bgcolor: 'primary.main',
            },
          }}
        />
        <Box alignContent="center" mt={1} display="flex" justifyContent="center">
          <Typography fontSize={12} variant="caption">
            <Trans
              i18nKey="birthdayGift.purchasesAmount"
              defaults="{{amountSpent, currency}} spent out of {{neededAmount, currency}}. {{remainingAmount, currency}} to go!"
              values={{
                amountSpent: BirthdayGiftStore.purchasesWithinPeriod,
                neededAmount: BirthdayGiftStore.birthdayGift?.minPurchaseValue,
                remainingAmount: (BirthdayGiftStore.birthdayGift?.minPurchaseValue ?? 0) - (BirthdayGiftStore.purchasesWithinPeriod ?? 0),
              }}
            />
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default observer(InProgress);
